"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Nothing = _interopRequireDefault(require("../Nothing"));

var LazyGate = function LazyGate(_ref) {
  var condition = _ref.condition,
      Component = _ref.Component,
      Alternate = _ref.Alternate;
  return condition ? /*#__PURE__*/_react["default"].createElement(Component, null) : /*#__PURE__*/_react["default"].createElement(Alternate, null);
};

LazyGate.propTypes = {
  condition: _propTypes["default"].bool.isRequired,
  Alternate: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]).isRequired,
  Component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]).isRequired
};
LazyGate.defaultProps = {
  Alternate: _Nothing["default"]
};
var _default = LazyGate;
exports["default"] = _default;